import React from 'react';
import Page from './components/layout/page/page';
import SearchSection from './components/smart/search-section/search-section';
import ResultSection from './components/smart/result-section/result-section';
import { LatLng } from 'leaflet';
import AuthContextProvider from './providers/auth-context';

function App() {
  const [isSearchSection, setIsSearchSection] = React.useState<boolean>(true);
  const [locationName, setLocationName] = React.useState<string>();
  const [locationPosition, setLocationPosition] = React.useState<LatLng>();

  const onCheckLocation = (name: string, lat: number, long: number) => {
    setLocationName(name);
    setLocationPosition(new LatLng(lat, long));
    setIsSearchSection(false);
  };

  const backToSearchSection = () => {
    setIsSearchSection(true);
  };

  return (
    <AuthContextProvider>
      <Page className="bg-appBg">
        {isSearchSection ? (
          <SearchSection onCheckLocation={onCheckLocation} />
        ) : (
          <ResultSection
            locationName={locationName}
            locationPosition={locationPosition}
            onNewSearch={backToSearchSection}
          />
        )}
      </Page>
    </AuthContextProvider>
  );
}

export default App;
